import { MenuProps } from 'components/Menu/Types'
import { Menu } from 'components/Menu/Menu'
import { Item, Section } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { setBlockType } from 'common/Prose/Commands/setBlockType'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { TEXT_STYLES } from 'common/Prose/constants'
import { H1, H2, H3, NormalText, Title } from 'blaze-ui/icons'

export const TextStyleSubmenu = observer(
  ({ onAction, menuType = 'dropdown' }: Pick<MenuProps<any>, 'menuType' | 'onAction' | 'aria-label'>) => {
    const editorState = useAlmanacEditorState()
    const view = useEditorView()
    const { activeStyles } = editorState || { activeStyles: new Set<keyof typeof TEXT_STYLES>() }

    const handleAction = (action: Key) => {
      onAction?.(action)
      setBlockType(action)(view.state, view.dispatch)
      view.focus()
    }

    return (
      <Menu
        onAction={handleAction}
        menuType={menuType}
        selectedKeys={activeStyles}
        selectionMode="single"
        aria-label="Text Style"
      >
        <Section>
          <Item key="normal">
            <NormalText /> Normal
          </Item>
          <Item key="title">
            <Title /> Title
          </Item>
          <Item key="heading1">
            <H1 /> Heading 1
          </Item>
          <Item key="heading2">
            <H2 /> Heading 2
          </Item>
          <Item key="heading3">
            <H3 /> Heading 3
          </Item>
        </Section>
      </Menu>
    )
  },
)
